import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fliterBlog'
})
export class FliterBlogPipe implements PipeTransform {

  transform(value: any, arg: any): any {
    const resultBlog = [];
    for (const blog of value) {
       if ((blog.titulo.toLowerCase().indexOf(arg.toLowerCase()) > -1)) {
         resultBlog.push(blog);
       }
     }
    return resultBlog;
  }
}

